import api from '@/security/api'
import errorCatch from '@/helpers/errorCatch'

require('./../../security/interceptors')

const all = () => {
    return api.get(`/services/all`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar a listagem de todos os serviços')
        })
}

const findAll = () => {
    return api.get(`/services`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar a listagem de serviços')
        })
}

const find = (id) => {
    return api.get(`/services/${id}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar o serviço')
        })
}

export default {
    all,
    findAll,
    find
}
